// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./images/clouds_bg.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./images/carved_stone_bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./images/bubbles_bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./images/red_blocks_bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./images/blue_rivets_bg.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("./images/metal_links_bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("./images/straw_mat_bg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Open+Sans&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html {
  --background-color: black;
  --text-color: white;
}

html[data-theme="(None)"] {
  --background-color: teal;
  --text-color: black;
}

html[data-theme="Clouds"] {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  height: 100vh;
  --text-color: black;
}

html[data-theme="Carved Stone"] {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  height: 100vh;
  --text-color: black;
}

html[data-theme="Bubbles"] {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  height: 100vh;
  --text-color: black;
}

html[data-theme="Red Blocks"] {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  height: 100vh;
  --text-color: black;
}

html[data-theme="Blue Rivets"] {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  height: 100vh;
  --text-color: black;
}

html[data-theme="Metal Links"] {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  height: 100vh;
  --text-color: black;
}

html[data-theme="Straw Mat"] {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  height: 100vh;
  --text-color: black;
}


body {
  margin: 0;
  font-family: 'Open Sans', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: var(--background-color);
  overflow: hidden;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

p {
  color: var(--text-color);
}

.progress {
  border-radius: 0;
  background-color: rgb(206, 208, 207);
  height: 1.5rem;
}

.progress-bar {
  background-color: #0949ff;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,yDAA+C;EAC/C,2BAA2B;EAC3B,4BAA4B;EAC5B,sBAAsB;EACtB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,yDAAqD;EACrD,2BAA2B;EAC3B,4BAA4B;EAC5B,sBAAsB;EACtB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,yDAAgD;EAChD,2BAA2B;EAC3B,4BAA4B;EAC5B,sBAAsB;EACtB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,yDAAmD;EACnD,2BAA2B;EAC3B,4BAA4B;EAC5B,sBAAsB;EACtB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,yDAAoD;EACpD,2BAA2B;EAC3B,4BAA4B;EAC5B,sBAAsB;EACtB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,yDAAoD;EACpD,2BAA2B;EAC3B,4BAA4B;EAC5B,sBAAsB;EACtB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,yDAAkD;EAClD,2BAA2B;EAC3B,4BAA4B;EAC5B,sBAAsB;EACtB,aAAa;EACb,mBAAmB;AACrB;;;AAGA;EACE,SAAS;EACT,oCAAoC;EACpC,mCAAmC;EACnC,kCAAkC;EAClC,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE;aACW;AACb;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Open+Sans&display=swap');\n\nhtml {\n  --background-color: black;\n  --text-color: white;\n}\n\nhtml[data-theme=\"(None)\"] {\n  --background-color: teal;\n  --text-color: black;\n}\n\nhtml[data-theme=\"Clouds\"] {\n  background-image: url('./images/clouds_bg.jpg');\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: cover;\n  height: 100vh;\n  --text-color: black;\n}\n\nhtml[data-theme=\"Carved Stone\"] {\n  background-image: url('./images/carved_stone_bg.png');\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: cover;\n  height: 100vh;\n  --text-color: black;\n}\n\nhtml[data-theme=\"Bubbles\"] {\n  background-image: url('./images/bubbles_bg.png');\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: cover;\n  height: 100vh;\n  --text-color: black;\n}\n\nhtml[data-theme=\"Red Blocks\"] {\n  background-image: url('./images/red_blocks_bg.png');\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: cover;\n  height: 100vh;\n  --text-color: black;\n}\n\nhtml[data-theme=\"Blue Rivets\"] {\n  background-image: url('./images/blue_rivets_bg.jpg');\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: cover;\n  height: 100vh;\n  --text-color: black;\n}\n\nhtml[data-theme=\"Metal Links\"] {\n  background-image: url('./images/metal_links_bg.png');\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: cover;\n  height: 100vh;\n  --text-color: black;\n}\n\nhtml[data-theme=\"Straw Mat\"] {\n  background-image: url('./images/straw_mat_bg.png');\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: cover;\n  height: 100vh;\n  --text-color: black;\n}\n\n\nbody {\n  margin: 0;\n  font-family: 'Open Sans', sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background-color: var(--background-color);\n  overflow: hidden;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\np {\n  color: var(--text-color);\n}\n\n.progress {\n  border-radius: 0;\n  background-color: rgb(206, 208, 207);\n  height: 1.5rem;\n}\n\n.progress-bar {\n  background-color: #0949ff;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
